// extracted by mini-css-extract-plugin
export default {"base":"style_base__KMLNB","info":"style_info__to+0j","root":"style_root__DjY-j"};